module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "main_menu"
  }, [_c('li', {
    class: {
      cur: _vm.menu.home
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.home ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'Teacher'
      }
    }
  }, [_vm._v("高中")])], 1), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.menu.junior
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.junior ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'Teachercz'
      }
    }
  }, [_vm._v("初中")])], 1), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.menu.about
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.about ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v("关于我们")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "curBg"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a_logo",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "com_name"
  }, [_vm._v("\n          维词\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee5965f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 102
// module chunks = 0